// extracted by mini-css-extract-plugin
export default {"FileList":"ViewCustomerApproval_FileList__zIZOL","FileWrapper":"ViewCustomerApproval_FileWrapper__CIDUE","NoDocumentsMessage":"ViewCustomerApproval_NoDocumentsMessage__WMZQs"};